import AnamnesisScreen from './Anamnesis'

export type { AnamnesisScreenProps } from './Anamnesis'

export default AnamnesisScreen
